'use client';
import React, { useEffect, useMemo, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import getCategoryList from '@/public/json/product_category_list.json';
import Title from '@/src/components/common/ui/text/Title.jsx';
import useDeviceTypeMobile from '@/src/hooks/useDeviceTypeMobile.jsx';
import { StyledCategoryList } from '@/src/components/common/eco/sections/category-list/category-list.style.js';
import CategorySingle from '@/src/components/common/ui/single-item/CategorySingle.jsx';


const CategoryList = ({ data }) => {
	const [getCategoryData, setCategoryData] = useState(() => getCategoryList);
	const isMobile = useDeviceTypeMobile();

	// Memoize the data update effect
	useEffect(() => {
		let mounted = true;

		const updateData = () => {
			if (!mounted) return;

			if (getCategoryList) {
				setCategoryData(getCategoryList);
			}

		};

		updateData();

		return () => {
			mounted = false;
		};
	}, []);


	// Memoize the renderCategoryDesktop function to prevent unnecessary re-renders
	const renderCategoryDesktop = useMemo(() =>
			// eslint-disable-next-line react/display-name
			(e, index) => {
				return (
					<Col md={3} key={index} className={'p-0'}>
						<CategorySingle title={e?.title} link={`/products?category=${e?.slug}`} mainImage={e?.images?.[0]?.full_path} hoverImage={e?.images?.[1]?.full_path} />
					</Col>
				);
			},
		[],
	);




	return (
		<StyledCategoryList className={`CategoryList `} id={'products'} >

			{
				data?.section_data?.subtitle &&
				<Container>
					<Row>
						<Col md={12}>
							<Title
								tag={'h2'}
								margin={'0 0 60px'}
								text={data?.section_data?.subtitle}
								color={'#fff'}
							/>
						</Col>
					</Row>
				</Container>

			}





			{
				getCategoryData && getCategoryData?.length > 0  &&
				<Container fluid>
					<Row>
						{
							getCategoryData && getCategoryData?.length > 0 &&
							getCategoryData?.map((e, index) => renderCategoryDesktop(e, index))
						}
					</Row>
				</Container>
			}



		</StyledCategoryList>
	);
};



export default React.memo(CategoryList);
